import React, { useState, useEffect, useRef } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  DatePicker,
  Uploader,
  Icon,
  Table,
  Message,
} from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import {
  isImageOrPdf,
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../utils/ValidatorUtils'
import { cloneDeep, isEmpty } from 'lodash-es'
import { LOCAL_DAY_TH, DD_MM_YYYY_SLASH, DATE_PICKER_FORMAT } from '../../constants/date'
import moment from 'moment'
import { sessionGetItemJSON, sessionGetItemStr } from '../../utils/sessionHelpers'
import PanelHeader from '../../components/PanelHeader/PanelHeader'
import IncomeRecordFileTable from '../incomeRecordWidget/IncomeRecordFileTable'
import { startLoading, doneLoading } from '../../utils/loading'
import { downloadSubProjectIncomeRecordAttacthment } from '../../redux/actions/subProjectIncomeRecord'
import notification from '../../utils/notification'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { sessionGetItemObj } from '../../utils/sessionHelpers'
import InputForm from '../../components/forms/input/InputForm'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'

export default function SubProjectIncomeRecordForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  setIsEnableEdit = () => {},
  ...props
}) {
  const triggerRef = React.useRef()
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(_schema)
  const [fileTableData, setFileTableData] = useState([])
  const [valueShow, setValueShow] = useState(false)
  // const [expenseForVal, setExpenseForValVal] = useState(_schema.expenseFor.value)
  const [fileTypeError, setFileTypeError] = useState(false)
  const [showPendingTaxList, setShowPendingTaxList] = useState(false)
  const projectCode = sessionStorage.getItem('projectCode')
  const subProjectCode = sessionStorage.getItem('subProjectCode')
  const subProjectPeriod = sessionStorage.getItem('subProjectPeriod')
  const { periodNo, startAndEndDate, periodOfLength } = sessionGetItemObj('subProjectPeriodInfo')
  const [titleLeftStr, setTitleLeftStr] = useState('')
  const [titleRightStr, setTitleRightStr] = useState('')

  const defaultMaxFileSize = 5

  useEffect(() => {
    setTitleLeftStr(`งวดที่ ${periodNo || ''} (${startAndEndDate || ''})`)
    setTitleRightStr(`งวดที่ ${periodNo || '0'} / ${periodOfLength || '0'}`)
    register('deleteFileIds', [])
    setFileTableData(formSchema?.attachFiles?.values)
  }, [formSchema])

  useEffect(() => {
    setValue(formSchema?.referenceNumber?.name, formSchema?.referenceNumber?.value)
    // setValue(
    //   formSchema?.voucherDate?.name,
    //   formSchema?.voucherDate?.value
    //     ? moment(formSchema.voucherDate.value, DD_MM_YYYY_SLASH).toDate()
    //     : null
    // )
    setValue(formSchema?.voucherNumber?.name, formSchema?.voucherNumber?.value)

    register('deleteFileIds', [])
    setFileTableData(formSchema?.attachFiles?.values)
    // console.log('formSchema', formSchema)
  }, [formSchema])

  const onPreview = async (fileObj) => {
    // console.log('onPreview', fileObj)
    startLoading()
    try {
      var file = await downloadSubProjectIncomeRecordAttacthment(fileObj.id)
      var fileName = fileObj.label

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    // console.log('onDownload', fileObj)
    startLoading()
    try {
      var file = await downloadSubProjectIncomeRecordAttacthment(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleDeleteFileTable = async (rowData) => {
    // console.log('handleDeleteFileTable', rowData)

    let arr = getValues('deleteFileIds') || []
    arr.push(rowData.id)
    setValue('deleteFileIds', arr)

    let _fileTable = fileTableData?.filter((item) => item.id != rowData.id)
    setFileTableData(_fileTable)
  }

  return (
    <>
      <Panel
        bordered
        style={{
          marginTop: 25,
          border: '1px solid #4e4b488c',
        }}
        header={<PanelHeader leftString={titleLeftStr} rightString={titleRightStr} />}
      >
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.voucherNumber.validators, formSchema.voucherNumber.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.voucherNumber.name]} />
            <Input
              name={formSchema.voucherNumber.name}
              defaultValue={formSchema.voucherNumber.value}
              inputRef={register(isValidators(formSchema.voucherNumber.validators))}
              placeholder={
                formSchema.voucherNumber.hint
                  ? formSchema.voucherNumber.hint
                  : formSchema.voucherNumber.label
              }
              disabled={formSchema.voucherNumber.disabled}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.referenceNumber.validators,
                formSchema.referenceNumber.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.referenceNumber.name]} />
            <Input
              name={formSchema.referenceNumber.name}
              defaultValue={formSchema.referenceNumber.value}
              inputRef={register(isValidators(formSchema.referenceNumber.validators))}
              placeholder={'ระบุ' + formSchema.referenceNumber.label}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.voucherDate.validators, formSchema.voucherDate.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.voucherDate.name]} />
            {/* <Input
              name={formSchema.voucherDate.name}
              defaultValue={formSchema.voucherDate.value}
              inputRef={register(isValidators(formSchema.voucherDate.validators))}
              placeholder={'ระบุ' + formSchema.voucherDate.label}
            /> */}

            <Controller
              key={formSchema.voucherDate.name}
              name={formSchema.voucherDate.name}
              control={control}
              defaultValue={
                // moment(schema.reportDate.value).format('YYYY-MM-DD')
                formSchema.voucherDate.value
                  ? moment(formSchema.voucherDate.value, DATE_PICKER_FORMAT).toDate()
                  : moment().startOf('day').toDate()
                // moment().startOf('day').toDate()
              }
              rules={isValidators(formSchema.voucherDate.validators)}
              render={(props) => {
                return (
                  <DatePickerCustom
                    {...props}
                    startDate={sessionGetItemStr('projectStartDate')}
                    endDate={sessionGetItemStr('projectEndDate')}
                  />
                  // <DatePicker
                  //   format={DATE_PICKER_FORMAT}
                  //   locale={LOCAL_DAY_TH}
                  //   block
                  //   oneTap
                  //   value={props.value}
                  //   onChange={(value) => {
                  //     props.onChange(value)
                  //     // onChangeReportDate(value)
                  //   }}
                  // />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.description.validators, formSchema.description.label)}
            </ControlLabel>
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <InputForm
              schema={formSchema.description}
              rows={4}
              componentClass="textarea"
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              hideLabel
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.attachFiles.validators, formSchema.attachFiles.label)}
            </ControlLabel>
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {/* <Message
              showIcon
              type="info"
              description={`ชนิดที่รองรับ : ${
                formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'
              }`}
              style={{ marginBottom: 10 }}
            /> */}
            <ErrorMessage error={errors[formSchema.attachFiles.name]} />
            <Controller
              key={formSchema.attachFiles.name}
              name={formSchema.attachFiles.name}
              control={control}
              rules={isValidators(formSchema.attachFiles.validators)}
              defaultValue={''}
              render={(props) => {
                return (
                  <Uploader
                    accept={formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'}
                    autoUpload={false}
                    disabled={formSchema.attachFiles.disabled}
                    fileListVisible={true}
                    listType="picture-text"
                    fileList={props.value || []}
                    multiple
                    onChange={(fileList) => {
                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                      } else {
                        let file = fileList[fileList.length - 1]

                        if (
                          file.blobFile.size >
                          (formSchema?.attachFiles?.fileSize || defaultMaxFileSize) * 1024 * 1024
                        ) {
                          notification.open('error', {
                            title: `ขนาดไฟล์เกิน ${
                              formSchema.attachFiles.fileSize || defaultMaxFileSize
                            } MB`,
                            duration: 5000,
                          })
                          return
                        }

                        if (isImageOrPdf(file.blobFile.type)) {
                          props.onChange(fileList)
                          setFileTypeError(false)
                        } else {
                          setFileTypeError(true)
                          notification.open('error', {
                            title:
                              'ชนิดที่รองรับ ' + formSchema.attachFiles.fileType ||
                              '.jpg, .jpeg, .png, .pdf',
                            duration: 5000,
                          })
                        }
                      }
                    }}
                    draggable
                  >
                    <div>
                      <Icon size="2x" icon="upload2" />
                      <small className="uploder__text"></small>
                      {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                        formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'
                      } , ขนาดไฟล์ไม่เกิน ${
                        formSchema.attachFiles.fileSize || defaultMaxFileSize
                      } MB`}
                    </div>
                    {/* <div style={{ lineHeight: '100px' }}>
                      <Icon size="4x" icon="upload2" />
                      <small
                        style={{
                          marginTop: '-70px',
                          display: 'block',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                      </small>
                    </div> */}
                  </Uploader>
                )
              }}
            />
          </Col>
          {/* <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          <Col lg={8} md={8} sm={24} xs={24}></Col> */}
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {fileTableData.length > 0 && (
              <IncomeRecordFileTable
                data={fileTableData}
                deleteable={true}
                onPreview={onPreview}
                onDownload={onDownload}
                onDelete={(rowData) => handleDeleteFileTable(rowData)}
              />
            )}
          </Col>
        </Row>
      </Panel>
    </>
  )
}
